export var ACTION;
(function (ACTION) {
    ACTION["LOAN_WEBVIEW"] = "LOAN_WEBVIEW";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["GO_NEXT"] = "GO_NEXT";
    ACTION["GO_LOAN_AUTO_PAY"] = "GO_LOAN_AUTO_PAY";
})(ACTION || (ACTION = {}));
